<template>
  <div class="deviceShow">
    <div id="wrapper">
      <div id="termometer">
        <div id="temperature" :style="{height:height+'%'}" :data-value="dataValue" />
        <div id="graduations" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "1",
      height: 100,
      dataValue: "38.9°C"
    };
  },
  mounted() {
    // const temperature = document.getElementById('temperature')
    // function setTemperature() {
    //   temperature.style.height = '100%'
    //   temperature.dataset.value = '30°C'
    // }
    // setTimeout(setTemperature, 1000)
  }
};
</script>
<style scoped>
body {
  display: flex;
  height: 100vh;
  margin: 0;
  background: #3d3d44;
  font-family: "Jaldi", sans-serif;
  font-size: 14px;
  color: white;
}

#wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #303133;
  width: 360px;
}

#termometer {
  width: 20px;
  background: #dadaee;
  height: 240px;
  position: relative;
  border: 9px solid #303133;
  border-radius: 20px;
  z-index: 1;
  margin-bottom: 50px;
  box-shadow: darkgrey 10px 10px 30px 10px;
}
#termometer:before,
#termometer:after {
  position: absolute;
  content: "";
  border-radius: 50%;
}
#termometer:before {
  width: 100%;
  height: 34px;
  bottom: 9px;
  background: #38383f;
  z-index: -1;
}
#termometer:after {
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background-color: #3dcadf;
  bottom: -41px;
  border: 9px solid #303133;
  /* margin: 3px; */
  z-index: -3;
  left: 50%;
}
#termometer #graduations {
  height: 59%;
  top: 20%;
  width: 50%;
}
#termometer #graduations,
#termometer #graduations:before {
  position: absolute;
  border-top: 2px solid rgba(0, 0, 0, 0.5);
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
}
#termometer #graduations:before {
  content: "";
  height: 34%;
  width: 100%;
  top: 32%;
}
#termometer #temperature {
  bottom: 0;
  background: linear-gradient(#f56c6c, #e6a23c, #67c23a, #3dcadf) no-repeat
    bottom;
  width: 100%;
  border-radius: 20px;
  background-size: 100% 240px;
  transition: all 0.2s ease-in-out;
}
#termometer #temperature,
#termometer #temperature:before,
#termometer #temperature:after {
  position: absolute;
}
#termometer #temperature:before {
  content: attr(data-value);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer #temperature:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid rgba(0, 0, 0, 0.7);
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
</style>
